import { UTCDeliveryPeriod } from '@epicuro-next/ataraxia/models';

import { BusinessState } from '../../../../models';
import { removeDateFromCacheReducer } from '../../cache-delivery-periods/update-delivery-periods-cache.reducer';
import { deleteFutureDeliveryPeriodReducerNew } from '../delete-future-delivery-period.reducer';

/** deprecated, Use only deleteFutureDeliveryPeriodReducerNew */
export function deleteFutureDeliveryPeriodBusiness(
  state: BusinessState,
  {
    deliveryPeriod,
    deliveryShopKey,
  }: { deliveryPeriod: UTCDeliveryPeriod; deliveryShopKey: string },
): BusinessState {
  const removingDeliveryPeriodKey = deliveryPeriod.from;

  return {
    ...state,
    ...deleteFutureDeliveryPeriodReducerNew(
      state,
      deliveryPeriod,
      deliveryShopKey,
    ),
    dirty: true,
    cached: removeDateFromCacheReducer(state.cached, removingDeliveryPeriodKey),
  };
}
